export default "__VITE_ASSET__DivwVGr4__"